module.exports = __webpack_public_path__ + "img/trust-shield.7b3e0d61.png";